module.exports = __webpack_public_path__ + "static/media/bg-home.57b11801.jpg";